import { Icon } from "@chakra-ui/react";
const SuccessIcon = () => {
  return (
    <>
    <Icon 
    width="10" 
    height="18" 
    viewBox="0 0 32 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <path 
    d="M29 3L13 21L3 13" 
    stroke="white" 
    strokeWidth="5"
    strokeMiterlimit="10" 
    strokeLinecap="round" 
    strokeLinejoin="round"/>
    </Icon>

    </>
  );
};

export default SuccessIcon;